<template>
    <div class="calculator-wrapper contentCenter">
        <div class="imgBox">
            <img :src="imgUrl" alt="food" class="imgStyle">
        </div>
        <div class="contentCenter">
            <div class="topContent">
                <p>冷氣每小時約會產生0.573kg的碳排放量</p>
                <span class="text-sm">資料來源：經濟部能源局「111年度電力排碳係數」</span>
            </div>
            <div class="yellowContent">
                <p>透過一週減少開冷氣<span>{{ count }}</span>個小時</p>
                <p>可為地球減少<span>{{ earth }}</span>kg的二氧化碳</p>
                <p>一年就可以減少<span>{{ year }}</span>kg！</p>
            </div>
            <div class="bottomContent">
                <h4>這些低碳生活小撇步，也能降低環境負擔：</h4>
                <li v-for="(tip, index) in tips" :key="index">{{ tip }}</li>
            </div>
        </div>
        <button @click.prevent="isShowResult" class="calculateStyle">再算一次</button>
    </div>
</template>

<script>
/* eslint-disable global-require */

export default {
    data() {
        return {
            picked: '',
            imgUrl: require('@/assets/calculator/004-air-conditioner.svg'),
            tips: [
                '汰換老舊家電，使用節能及省水設備。',
                '使用帶有開關的延長線，不使用電器時關閉電源。',
                '冷氣設定26-28℃。',
                '隨手關燈。',
            ],
        };
    },
    props: {
        count: {
            type: Number,
            require: false,
        },
        earth: {
            type: Number,
            require: false,
        },
        year: {
            type: Number,
            require: false,
        },
    },
    methods: {
        submitResult() {
            this.$emit('get-result', this.picked);
        },
        isShowResult() {
            this.$emit('show-question', false);
        },
        goView(link) {
            this.$router.push(link).catch(() => { });
        },
    },
};
</script>

<style lang="sass" scoped>
.imgBox
    width: 110px
    height: 110px

.imgStyle
    width: 100%
    height: 100%
    object-fit: contain

.topContent
    p
    font-weight: 600
    font-size: 14px
    line-height: 18px
    margin-bottom: 0 !important

.yellowContent
    background-color: #FFFAEE
    padding: 24px
    p
        font-weight: 700
        font-style: normal
        font-size: 20px
        line-height: 32px
        span
            color: #F59A23

.bottomContent
    border: 3px solid rgba(0, 128, 128, 1)
    border-radius: 10px
    padding: 12px
    h4
        font-weight: 700
        font-style: normal
        font-size: 19px
        color: #008080
        line-height: 24px
</style>
